import { LoadingButton } from '@mui/lab'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useCheckIfAwbExistQuery, useReuploadAwbMutation } from 'src/_api/orderApi'

export default function CheckIsAwbUploaded({
  orderFrom,
  orderId,
  onError = () => { },
}) {
  const { t } = useTranslation()

  const { data, isLoading } = useCheckIfAwbExistQuery(orderId, { skip: orderFrom === "ZID" ? false : true })

  console.log("CheckIsAwbUploaded: ", data)

  const [reuploadAwb, {
    isLoading: isReuploadingAwb,
    isSuccess: isReuploadAwbSuccess,
    error: reuploadAwbError
  }] = useReuploadAwbMutation()

  useEffect(() => {
    if (reuploadAwbError) {
      onError(reuploadAwbError)
    }
  }, [reuploadAwbError, onError])

  return (
    <>
      {
        (orderFrom === "ZID" && data === false && !isReuploadAwbSuccess) &&
        <LoadingButton
          variant='contained'
          sx={{ textTransform: "none" }}
          loading={isReuploadingAwb}
          onClick={() => {
            onError(null)
            reuploadAwb(orderId)
          }}
        >
          {t("Re-upload AWB")}
        </LoadingButton>
      }
    </>
  )
}
